<template>
  <div v-if="isKiosk" id="app">
    <Kiosk></Kiosk>
  </div>
  <div v-else id="app">
    <Loader v-show="tenduLoading"></Loader>
    <TopHeader></TopHeader>
        <keep-alive exclude="qrcode, scan, climbostatics">
          <router-view></router-view>
        </keep-alive>
    <SectorMap></SectorMap>
  </div>

</template>

<script>

import SectorMap from './components/SectorMap'
import TopHeader from './components/TopHeader'
import Loader from './components/Loader'
import Kiosk from './components/Kiosk/Kiosk'
import Booking from './components/User/Booking'

import { mapState } from 'vuex'

export default {
  name: 'app',
  components: {
    TopHeader,
    SectorMap,
    Kiosk,
    Loader,
    Booking
      },

  data () {
    return {
      preload: false,
      isPermision: false,
      isKiosk: false,
    }
  },

  computed: {
    ...mapState([
      'tenduLoading',
    ]),
  },

  created() {
    var defineUrl = window.location.hash
    // console.log('Define entry', defineUrl)
    if (defineUrl === '#/PKeWl2EWHdsv6PMzv0CFOZsa992J0bnq') {
      return this.isKiosk = true
    } else {
      return this.isKiosk = false
    }
  }
}

</script>

<style>

  .md-theme-default a:not(.md-button):hover {
    text-decoration:none;
  }

  .md-snackbar-container {
    background-color: rgba(0, 131, 143, 0.85) !important;
    font-size:16px !important;
  }

  .star-rating {
    max-width:90px;
    display:inline !important;
  }

  #routelist span.rating-text, #routelog span.rating-text, #routedetails span.rating-text, #routeclimbed span.rating-text,  #guestrating .vue-star-rating-rating-text {
    display:none !important;
  }

  span.rating-text {
    color:rgba(0, 0, 0, .57) !important;
    font-size:15px !important;
    vertical-align: sub !important;
  }

  .md-toolbar .md-button.md-icon-button {
    margin:0px 0px !important;
  }

  .listBar {
    width:100%;
    top:0px;
    position:fixed;
    z-index:12;
  }

  h2.md-title {
    flex: 1;
  }

  .md-toolbar h2.md-title {
    margin-left:24px !important;
  }

  h2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .climber {
    width:36px;
    height:36px;
    background-image: url('assets/climber.png');
    background-size:contain;
  }

  .mixedColor {
    background:url('./assets/mixed_color.jpg') no-repeat transparent;
    background-size: 24px 24px;
  }

  .doubleColor {
    background: linear-gradient(90deg, pink 50%, cyan 50%);
  }

  .whiteColor {
    background-color:#ffffff;
    border: 1px solid grey;
  }

  .md-avatar {
    text-align:center;
    font-weight:bolder;
  }

  .md-table.md-table-cell.md-numeric.md-table-cell-container, .md-table .md-table-cell.md-numeric, .md-table .md-table-head.md-numeric, .md-table-cell-container {
    text-align:left !important;
    justify-content: left !important;
  }

  .md-table, .md-table-row  .md-table-cell, .md-selection{
    border:none !important;
  }

  .vdp-datepicker input {
    font-size:16px;
    font-family:'roboto';
    width:100%;
    border:none;
  }

  .vdp-datepicker__calendar {
    max-width:350px;
    min-width:250px;
    width: unset;
    border:none;
  }

  .vdp-datepicker input:focus {
    border: none;
    outline:none;
    }

  .vdp-datepicker__calendar .cell.day.selected  {
    background-color: #00838f;
    color:#ffffff;
    border-radius:4px;
    border:none;
    background-repeat: no-repeat;
    background-position: 50% -1px;
  }

  .vdp-datepicker__calendar .cell.day:hover:not(.blank):not(.disabled) {
    background-color: #ffffff;
    border:none;
    border-radius:50%;
    background-repeat: no-repeat;
    background-position: 50% -50px;
  }

  .vdp-datepicker__calendar .cell.month.selected {
    background-color: #00838f;
    border:none;
    color:#ffffff;
  }
  .vdp-datepicker__calendar .cell.month:hover:not(.blank):not(.disabled) {
    border:none;
    background-color:#efefef;
  }

  .vdp-datepicker__calendar .cell.year.selected {
    background-color: #00838f;
    border:none;
    color:#ffffff;
  }
  .vdp-datepicker__calendar .cell.year:hover:not(.blank):not(.disabled) {
    border:none;
    background-color:#efefef;
  }

  .vdp-datepicker__calendar .cell.selected {
    border:none !important;
    }

  .vdp-datepicker__calendar header {
    background-color: #C51162 !important;
    height:72px;
    color:#ffffff;
    font-size:20px;
    padding-top:15px;
    margin:auto;
    font-family:"Roboto"
  }

  .vdp-datepicker__calendar header .next:after {
    border-left: 10px solid #fff !important;
  }
  .vdp-datepicker__calendar header .prev:after {
    border-right: 10px solid #fff !important;
  }

  .vdp-datepicker__calendar header .next:not(.disabled):hover, .vdp-datepicker__calendar header .prev:not(.disabled):hover, .vdp-datepicker__calendar header .up:not(.disabled):hover {
    background-color:transparent !important;
  }

  .userlink {
    font-weight:bold;
    cursor:pointer;
    line-height:17px;
    color:#00838f !important;
  }

  .userlink:hover {
    color:#C51162 !important
  }

  .previewback {
    height:100%;
    width:100%;
    position:fixed;
    z-index:40;
    top:0px;
    background-color:rgba(0,0,0,.54);
  }

  .md-spinner {
    display:block;
    margin:auto;
    top: 45%;
  }

  .browse {
    width:45%;
    position:fixed;
    z-index:300 !important;
    top:0px; background-color:#00838f;
    border:none; color:white;
    height: 64px;
    margin-left:72px;
    margin-top:-4px;
  }

  .progress {
    background-color:rgba(0, 131, 143, 0.7);
    position:fixed;
    top:0px;
    z-index:100;
    width:100%;
    display:block;
    height:100%;
  }

  .greenSpinner {
    background-color:rgba(0, 131, 143, 0.7);
    position:fixed;
    top:0px;
    z-index:100;
    width:100%;
    display:block;
    height:100%;
  }

  .loader {
    background-color:#ffffff;
    height:88px;
    position:fixed;
    margin:auto;
    width:100%;
    bottom:0px;
    z-index:15;
    color:#C51162;
    padding-top:25px;
    text-align:center;
  }

  .loader > div {
    width: 8px;
    height: 8px;
    background-color: #00838f;
    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .loader .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .loader.bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }

  #gymroutelist .md-table .md-table-cell .md-table-cell-container{
    padding:6px 6px 6px 6px !important;
  }

  #gymroutelist .md-theme-default.md-table-alternate-header .md-toolbar {
    background-color:#ffffff !important;
  }

  #gymroutelist .md-table-head-text.md-test {
    line-height:16px !important;
    height:48px !important;
    white-space: normal !important;
    padding-left:6px !important;
    padding-right:6px !important;
    padding-top:6px !important;
    font-size:13px;
  }

  #gymroutelist .md-table .md-table-cell {
    max-height:45px !important;
  }

  #gymroutelist .md-sortable-icon {
    display:none !important;
  }

  #gymroutelist .md-table .md-table-selection {
    width:30px;
  }

  input.md-input {
    font-weight:400 !important;
    font-size:16px !important;
  }

  #sectordetails, #routelist, #kiosklist, #routedetails, #routeclimbed, #routelog, #gymdashboard,
  #filterdiff, #filterstyle, #gymroutelist, #gymlist, #gymedit, #gymadd, #guestrating, #routesadd, #booking {
    background-color: #ffffff;
    z-index: 11;
    height: 100%;
    width:100%;
    position: absolute;
  }

  .longInfo {
    position:relative;
    z-index:190;
    height: 100%;
    background-color:#ffffff;
    padding-bottom:50px;
  }

  #routedetails {
    /* overflow-x:hidden; */
  }

  .md-backdrop {
    background-color: rgba(0, 131, 143, 0.65) !important;
  }

  .UIAAstyle {
    text-align:left;
    z-index:11;
    position:relative;
    top:96px;
    left:16px;
    height:30px;
    color:rgb(0, 131, 143,0.7);
    background-color:#ffffff;
    width:50px;
    transform: rotate(-90deg);
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
  }

  .md-caption {
    font-size:13px !important;
  }

  .switchLoc {
    position:absolute;
    top:175px;
    right:65px;
    z-index:500;
  }

  .whiteDarkTurquoise {
    background: linear-gradient(90deg, white 50%, DarkTurquoise 50%) !important;
    border: 1px solid grey;
  }

  .whitePurple {
    background: linear-gradient(90deg, white 50%, purple 50%) !important;
    border: 1px solid grey;
  }

  .whitePink {
    background: linear-gradient(90deg, white 50%, pink 50%) !important;
    border: 1px solid grey;
  }

  .whiteRed {
    background: linear-gradient(90deg, white 50%, red 50%) !important;
    border: 1px solid grey;
  }

  .blackYellow {
    background: linear-gradient(90deg, black 50%, yellow 50%) !important;
  }

  .blueOrange {
    background: linear-gradient(90deg, blue 50%, orange 50%) !important;
  }

  .structure {
    background: linear-gradient(40deg, #646464 15%, #000000 70%, #646464 15%) !important;
  }

</style>
